module.exports = __webpack_public_path__ + "img/invite_mark.23134a89.svg";